import {useRoutes,useLocation} from "react-router-dom";
import { useEffect } from "react";
import pageRoutes from "./pageRoutes";
import nprogress from "nprogress";
export default function Router(){
const routes=useRoutes([...pageRoutes]);
let location = useLocation();
useEffect(() => {
  nprogress.start();
  nprogress.done();
}, [location.pathname]);
return routes;
}
